import { KeycloakContext } from '@web/modules/core'
import { useContext } from 'react'

export const useKeycloak = () => useContext(KeycloakContext)
